class ProductMediaGalleryProgress extends HTMLElement {
  connectedCallback() {
    const media_gallery = this.closest('media-gallery');

    this.scroller = media_gallery?.querySelector('slideshow-slides');
    this.progress_thumb = this.querySelector('.product-media-gallery-progress__thumb');

    if (!this.scroller || !this.progress_thumb) {
      return;
    }

    this.update_progress = this.update_progress.bind(this);
    this.scroller.addEventListener('scroll', this.update_progress, { passive: true });

    this.resize_observer = new ResizeObserver(this.update_progress);
    this.resize_observer.observe(this.scroller);

    requestAnimationFrame(this.update_progress);
  }

  disconnectedCallback() {
    if (this.scroller) {
      this.scroller.removeEventListener('scroll', this.update_progress);
    }

    if (this.resize_observer) {
      this.resize_observer.disconnect();
    }
  }

  update_progress() {
    const max_scroll = this.scroller.scrollWidth - this.scroller.clientWidth;

    if (max_scroll <= 0) {
      this.hidden = true;
      return;
    }

    this.hidden = false;

    const progress_width = this.clientWidth;
    const thumb_width = this.progress_thumb.offsetWidth;
    const max_offset = progress_width - thumb_width;
    const scroll_ratio = this.scroller.scrollLeft / max_scroll;
    const thumb_offset = max_offset * scroll_ratio;

    this.style.setProperty('--product-media-gallery-progress-offset', `${thumb_offset}px`);
  }
}

if (!customElements.get('product-media-gallery-progress')) {
  customElements.define('product-media-gallery-progress', ProductMediaGalleryProgress);
}
